import { Link } from 'react-router-dom';
import { AppImage } from '@/shared/ui/AppImage';
import { Svg } from '@/shared/ui/Svg';
import ArrowUpRight from '@/shared/assets/icons/arrow_up_right.svg';

interface BlogCardProps {
  title: string;
  href: string;
  excerpt: string;
  image?: string | null;
}

export const BlogCard = ({ title, href, excerpt, image }: BlogCardProps) => (
  <article className="group relative flex h-full min-w-0 w-full flex-col gap-y-3 bg-white p-4">
    <AppImage
      src={image ?? undefined}
      alt=""
      className="max-h-[240px] w-full rounded-[14px] object-cover"
    />
    <h3 className="line-clamp-2 text-lg font-medium">
      <Link to={href} className="after:absolute after:inset-0">
        {title}
      </Link>
    </h3>
    {excerpt ? <p className="line-clamp-2 font-medium text-[#4D4D4D]">{excerpt}</p> : null}
    <div className="mt-auto flex items-center justify-end gap-3">
      <span
        aria-hidden
        className="inline-flex items-center gap-x-2 text-sm transition-colors group-hover:text-neutral-600"
      >
        Read more
        <Svg Icon={ArrowUpRight} />
      </span>
    </div>
  </article>
);
